import Table, { ColumnsType } from 'antd/lib/table';
import { Button, Col, Form, Input, Popconfirm, Row, Select, Space } from 'antd';
import React from 'react';
import { Project, projectStatusKorean } from '../../modules/projects';
import styled from 'styled-components';
import { styledTable } from '../styled/mixin';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';

const StyledDiv = styled.div`
  ${styledTable}
`;

const { Option } = Select;

interface ProjectListComponentProps {
  onDelete: (projectId: number) => void;
  onSearch: (values: any) => void;
  data: Project[] | null;
  moveToCreatePage: () => void;
  moveToDetailPage: (projectId: number) => void;
}

function ProjectListComponent({
  onDelete,
  onSearch,
  data,
  moveToCreatePage,
  moveToDetailPage,
}: ProjectListComponentProps) {
  const [form] = Form.useForm();
  const columns: ColumnsType<Project> = [
    {
      title: '공사명',
      dataIndex: 'name',
      ellipsis: true,
      width: '27%',
      sorter: (a: Project, b: Project) => a.name.localeCompare(b.name),
      render: (text: any, record: any) => (
        <>
          <span
            className="clickable-table-item"
            onClick={() => moveToDetailPage(record.id)}
          >
            {text}
          </span>
        </>
      ),
    },
    {
      title: '발주처',
      dataIndex: 'owner',
      sorter: (a: Project, b: Project) => a.owner?.localeCompare(b?.owner),
      ellipsis: true,
      width: '15%',
    },
    {
      title: '위치',
      // dataIndex: 'location',
      ellipsis: true,
      width: '20%',
      render: (text: any, record: Project) =>
        `${record.location} ${
          record.detailedLocation ? record.detailedLocation : ''
        }`,
    },
    {
      title: '상태',
      dataIndex: 'status',
      width: '10%',
      sorter: (a: Project, b: Project) =>
        projectStatusKorean[a.status].localeCompare(
          projectStatusKorean[b.status],
        ),
      render: (text: any, record: Project) =>
        projectStatusKorean[record.status],
    },
    {
      title: '공사 시작일',
      dataIndex: 'startDate',
      sorter: (a: Project, b: Project) =>
        a.startDate.localeCompare(b.startDate),
      width: '10%',
    },
    {
      title: '공사 종료일',
      dataIndex: 'endDate',
      sorter: (a: Project, b: Project) => a.endDate.localeCompare(b.endDate),
      width: '10%',
    },
    {
      title: '',
      key: 'action',
      align: 'center',
      width: '10%',
      render: (text, record, index) => (
        <Space size="small">
          <div onClick={(e) => e.stopPropagation()}>
            <Popconfirm
              title="정말 삭제하시겠습니까?"
              data-test={`project-list-item-${index}`}
              onConfirm={() => onDelete(record.id)}
            >
              <Button size="small">삭제</Button>
            </Popconfirm>
          </div>
        </Space>
      ),
    },
  ];

  return (
    <StyledDiv>
      {/* <Row>
        <Col>
          <Title level={3}>공사관리</Title>
        </Col>
      </Row> */}
      <Row style={{ height: '20px' }} justify={'space-between'}>
        <Space>
          <Form
            form={form}
            name="advanced_search"
            className="ant-advanced-search-form"
            layout="inline"
            size="small"
            onFinish={onSearch}
          >
            <Col flex={6}>
              <Form.Item name="name">
                <Input
                  placeholder="공사명을 입력 후 엔터키를 누르세요."
                  style={{ width: '300px' }}
                  allowClear
                />
              </Form.Item>
            </Col>
            <Col flex={4}>
              <Form.Item name="owner">
                <Input
                  placeholder="발주처명을 입력 후 엔터키를 누르세요."
                  style={{ width: '200px' }}
                  allowClear
                />
              </Form.Item>
            </Col>
            <Col flex={2}>
              <Form.Item name="status" style={{ width: '150px' }}>
                <Select
                  allowClear
                  placeholder="상태를 선택 하세요."
                  style={{ width: '150px' }}
                >
                  {/* <Option value="0">진행 중</Option>
                  <Option value="1">종료</Option>
                  <Option value="2">견적 중</Option>
                  <Option value="3">준공 후</Option> */}
                  <Option value="2">{projectStatusKorean['2']}</Option>
                  <Option value="0">{projectStatusKorean['0']}</Option>
                  <Option value="1">{projectStatusKorean['1']}</Option>
                  <Option value="3">{projectStatusKorean['3']}</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col flex={1}>
              <Button
                htmlType="submit"
                icon={<SearchOutlined rev={undefined} />}
              >
                검색
              </Button>
            </Col>
          </Form>
        </Space>
        <Col>
          <Button
            onClick={moveToCreatePage}
            data-test="create-project-btn"
            size="small"
            icon={<PlusOutlined rev={undefined} />}
          >
            등록
          </Button>
        </Col>
      </Row>

      {data && (
        <Table<Project>
          rowKey="id"
          columns={columns}
          dataSource={data}
          style={{ marginTop: '10px' }}
          pagination={{
            defaultPageSize: 20,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30', '50', '100', '300'],
            position: ['bottomCenter'],
          }}
          locale={{
            triggerDesc: '내림차순으로 정렬하려면 클릭하세요.',
            triggerAsc: '오름차순으로 정렬하려면 클릭하세요.',
            cancelSort: '정렬을 취소하려면 클릭하세요.',
          }}
        />
      )}
    </StyledDiv>
  );
}

export default ProjectListComponent;
